<template>
  <div class="crumb">
    <div class="flex-row">
      <div style="display: flex;align-items: center;">
        <div style="font-size: 14px;color: #91959A;width: 70px;">当前位置：</div>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="(item, index) of levelList"
                              :key="index">{{item}}</el-breadcrumb-item>
          <el-breadcrumb-item v-if="times">{{times}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-button size="small" v-if="isShowBack" @click="back(pageurl)">返回</el-button>
    </div>
    <div class="class-info">
      <div class="class-nav" v-if="classInfo">
        <span>班级名称：</span>
        <span v-if="classInfo.className">{{classInfo.className}}</span>
        <el-select class="el-select_2" v-model="selectValue" filterable placeholder="请选择" @change="handleCommand" v-else>
          <el-option
            v-for="item in selectData"
            :key="item.classId"
            :label="item.className"
            :value="item.classId">
          </el-option>
        </el-select>
        <!--<el-dropdown v-else @command="handleCommand" >
          <span class="el-dropdown-link" style="color: #409eff;font-weight: bold; font-size: 16px" >
            {{selectValue}}<i class="el-icon-caret-bottom el-icon&#45;&#45;right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in selectData" :command="item.classId" :key="item.classId">{{item.className}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>-->
        <span><b>|</b>学生人数：{{classInfo.studentNumber}}人</span>
        <span v-if="classInfo.examTypeName && isTeaBank !== '-11'"><b>|</b>试卷类型：{{loginInfo.examTypeName}}</span>
        <el-button size="small" class='export-btn' @click="resultExport" v-if="showExport">导出</el-button>
      </div>
    </div>
    <el-dialog
      title="导出"
      top="38vh"
      :visible.sync="dialogVisible"
      width="500px">
      <div class="exam-practice-export">
        <el-radio-group v-model="radio">
          <el-radio :label="1">第一次作答成绩</el-radio>
          <el-radio :label="0">最高分作答成绩</el-radio>
          <el-radio :label="2">平均分</el-radio>
        </el-radio-group>
        <div>
          <el-button style="margin-top: 30px;width: 100px" type="primary" @click="examPracticeExport">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getDynExamClassResource } from '@/api/overall'
import { getExamTypeId, setExamClassId } from '@/utils/auth'
import { reportExport, mainExport, examPracticeExport, trainingPracticeExport } from '@/api/teacher/dynExam/studyProcess'
import { timestampToTime } from '@/utils/dateFomate'
import { OverallApi } from '@/api/competition/overall'
export default {
  data () {
    return {
      levelList: null,
      times: null,
      selectData: [],
      selectValue: '',
      isTeaBank: getExamTypeId() + '',
      dialogVisible: false,
      radio: 1
    }
  },
  props: {
    isShowBack: {
      type: Boolean,
      default: false
    },
    pageurl: {
      type: String,
      default: ''
    },
    classInfo: {
      type: Object,
      default: null
    },
    showExport: {
      type: Boolean,
      default: false
    },
    exportType: {
      type: String,
      default: ''
    },
    resourceExamPaperId: {
      type: String,
      default: ''
    },
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  computed: {
    ...mapGetters(['loginInfo'])
  },
  methods: {
    // ...mapActions('user', ['setLoginInfo']),
    getBreadcrumb () {
      let array = []
      if (this.$route.query.headList && !this._.isArray(this.$route.query.headList)) {
        array.push(this.$route.query.headList)
      } else {
        array = this.$route.query.headList || []
      }
      this.levelList = array.concat(this.$route.meta.headList || [])
    },
    back (pageurl) {
      if (pageurl !== '') {
        this.$router.push({ name: pageurl })
        return
      }
      history.go(-1)
    },
    handleCommand (classId) {
      this.selectData.forEach(item => {
        if (item.classId === classId) {
          this.selectValue = item.className
          setExamClassId(classId)
          this.setLoginInfo(Object.assign(this.loginInfo, {
            examClassId: classId,
            examClassName: item.className
          }))
        }
      })
    },
    // 获取班级列表
    async getDynExamClassResource () {
      this.selectData = this.$checkApiServer(await getDynExamClassResource())
    },
    // 成绩导出
    async resultExport () {
      if (this.exportType === '1') {
        this.dialogVisible = true
        return
      }
      let api = null
      let str = '动态考试测评-' + this.selectValue
      let obj = {}
      if (this.exportType === '2') {
        api = mainExport
        str += '-成绩'
      } else if (this.exportType === '3') {
        api = trainingPracticeExport
        str = this.selectValue + '-' + this.loginInfo.examTypeName + '-' + this.$parent.info.trainingName + '-得分详情'
        // 增加导出按钮，导出文件名：班级名称-试卷类型-专项练习类型-得分详情，例如：默认班级-TBEM4-Listening Comprehension-TBEM4-2019-P1-S1得分详情；
        obj = {
          trainingType: this.$route.query.trainingType,
          chapterId: this.$route.query.chapterId,
          trainingId: this.$route.query.trainingId
        }
      } else {
        api = reportExport
        str += '-' + this.loginInfo.examTypeName + '-学生成绩'
      }
      let uri = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + this.$checkApiServer(await api(obj))
      let link = document.createElement('a')
      link.href = uri
      if (this.exportType === '3') {
        link.download = `${str}.xlsx`
      } else {
        link.download = `${str}-${timestampToTime(new Date().getTime()).split(' ')[0]}.xlsx`
      }
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    // 真题模考 导出
    async examPracticeExport () {
      let str = '真题模考-' + this.classInfo.className + '-' + this.resourceExamPaperName
      if (getExamTypeId() === '-11') str = '教师题库-' + this.classInfo.className + '-' + this.resourceExamPaperName
      if (this.radio === 1) str += '-第一次作答'
      if (this.radio === 0) str += '-最高分'
      if (this.radio === 2) str += '-平均分'

      let uri = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + this.$checkApiServer(await examPracticeExport({
        exportType: this.radio, // (string)导出类型。0：最高分（默认）；1：首次；2：平均分
        resourceExamPaperId: this.resourceExamPaperId // (string)试卷id
      }))
      let link = document.createElement('a')
      link.href = uri
      link.download = `${str}-${timestampToTime(new Date().getTime()).split(' ')[0]}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.dialogVisible = false
    },


  },
    async mounted () {
    const times = this.$route.query.times
    if (times) this.times = times
    await this.getDynExamClassResource()
    this.selectData.forEach(item => {
      if (item.classId === this.loginInfo.examClassId) {
        this.selectValue = item.className
      }
    })
  },
  created () {
    this.getBreadcrumb()
  }
}
</script>

<style lang="scss" scoped>
  .crumb {
    position: relative;
    .el-breadcrumb {
      display: block;
      font-size: 14px;
      line-height: 50px;
      width: 1000px;
      .no-redirect {
        color: #91959A;
        font-size: 14px;
        cursor: text;
      }
      .active {
        color: #101D37;
      }
    }
    .class-info {
      position: absolute;
      top: 50%;
      transform: translateY(-44%);
      right: 65px;
      display: flex;
      align-items: center;
      /*border: 1px solid #df1263;*/
      /*width: 600px;*/
      .class-nav {
        font-size: 14px;
        color: #606266;
        margin-right: 10px;
        b {
          margin: 0 9px;
          font-weight: 700;
          color: #C0C4CC;
        }
        .el-dropdown-link {
          cursor: pointer;
        }
      }

    }
    .export-btn {
      margin-left: 15px;
    }
  }
</style>
